import {ProrataPeriod} from "../common/types";
import {FieldCostItem} from "./types";

export type InputChange<TAction extends string, TNewValueType> = {
	type: TAction
	fieldId: number
	formType: string
	to: TNewValueType
}

export type SetProrataPeriodAction = InputChange<"set prorata period", ProrataPeriod>
export type FieldCostItemAction = SetProrataPeriodAction // specifically for types which modify FieldCostItem's.
export type FieldCostItemAppAction = FieldCostItemAction | {type: "this is not intended to be instantiated"} //for any of them

/**
 * Find an item with the correct ID and return a copy of it with the new properties assigned.
 * @param action The action specifies which item it wants to operate on.
 * @param item The item to compare, to see if it needs to be modified or not.
 * @param newProperties The new properties to assign to item if it does match.
 */
const modifyItemIfMatches = <TAction extends string, TNewValueType>(action: InputChange<TAction, TNewValueType>, item: FieldCostItem, newProperties: {[key: string]: TNewValueType}): FieldCostItem =>
	item.field.id === action.fieldId && item.formType == action.formType
		? {...item, ...newProperties}
		: item

const updateProrataPeriodIfMatches = (action: SetProrataPeriodAction) => (item: FieldCostItem): FieldCostItem =>
	modifyItemIfMatches(action, item, {prorataPeriod: action.to})

export const fieldCostItems = (state:FieldCostItem[] = [], action: FieldCostItemAppAction): FieldCostItem[] => {
	switch(action.type) {
		case "set prorata period": return state.map(updateProrataPeriodIfMatches(action as SetProrataPeriodAction))
	}
	// This has stay here because this reducer is used with Redux's combineReducers() function, which means
	// we may be passed actions other than FieldCostItemAppAction.
	return state
}

export const ChangeActions = {
	prorataPeriod: (fieldCostItem: FieldCostItem, prorataPeriod: ProrataPeriod): SetProrataPeriodAction => { return {
		type: "set prorata period",
		fieldId: fieldCostItem.field.id,
		formType: fieldCostItem.formType,
		to: prorataPeriod
	}},
}


// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/field-items/reducer.ts